import React, { useEffect, useState } from "react";
import { Nav, Navbar } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import sukaniLogoEnglish from "../Images/sukaniLogoEnglish.png";
import Menu from "./Menu";
import "./Navbar.css";
import { Animated } from "react-animated-css";
function NavBar() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    window.onscroll = () => {
      const scrollHeight = document.body.scrollHeight;

      console.log((scrollHeight * 10) / 100, window.pageYOffset);

      if (window.pageYOffset > (scrollHeight * 10) / 100) {
        console.log(window.pageYOffset);
        setOpen(true);
      }
      if (window.pageYOffset < (scrollHeight * 10) / 100) {
        console.log(window.pageYOffset);
        setOpen(false);
      }
    };
  });
  return (
    <>
      <Menu />
      <Animated
        animationIn="bounceInDown"
        animationOut="fadeOut"
        isVisible={true}
      >
        <img src={sukaniLogoEnglish} className="navLogo navLogoAbsolute" />
      </Animated>
      {/* <Navbar.Collapse id="basic-navbar-nav ">
          <Nav className="ml-auto">
            <Nav.Link>
              <NavLink to="/aboutus" className="navLink">
                About us
              </NavLink>
            </Nav.Link>
            <Nav.Link>
              <NavLink to="/exports" className="navLink">
                Exports
              </NavLink>
            </Nav.Link>
            <Nav.Link>
              <NavLink to="/media" className="navLink">
                Media
              </NavLink>
            </Nav.Link>
            <Nav.Link>
              <NavLink to="/products" className="navLink">
                Products
              </NavLink>
            </Nav.Link>
            <Nav.Link>
              <NavLink to="/recipes" className="navLink">
                Recipes
              </NavLink>
            </Nav.Link>
            <Nav.Link>
              <NavLink to="/contactus" className="navLink">
                Contact
              </NavLink>
            </Nav.Link>
          </Nav>
        </Navbar.Collapse> */}
      {/* </Navbar> */}

      {open ? (
        <Animated
          animationIn="bounceInDown"
          animationOut="fadeOut"
          isVisible={open}
        >
          <Navbar
            className="positionFixed"
            fixed="top"
            style={{ background: "white" }}
          >
            <Navbar.Brand>
              <NavLink to="/">
                <img src={sukaniLogoEnglish} className="navLogo" />
              </NavLink>
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav ">
              <Nav className="ml-auto">
                <Nav.Link>
                  <NavLink to="/aboutus" className="navLink">
                    About us
                  </NavLink>
                </Nav.Link>
                <Nav.Link>
                  <NavLink to="/exports" className="navLink">
                    Exports
                  </NavLink>
                </Nav.Link>
                <Nav.Link>
                  <NavLink to="/media" className="navLink">
                    Media
                  </NavLink>
                </Nav.Link>
                <Nav.Link>
                  <NavLink to="/products" className="navLink">
                    Products
                  </NavLink>
                </Nav.Link>
                <Nav.Link>
                  <NavLink to="/recipes" className="navLink">
                    Recipes
                  </NavLink>
                </Nav.Link>
                <Nav.Link>
                  <NavLink to="/contactus" className="navLink">
                    Contact
                  </NavLink>
                </Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Navbar>
        </Animated>
      ) : null}
    </>
  );
}

export default NavBar;
